import useBundleTranslation from 'i18n';
import { useAppBuilderContext } from 'app/app/editor/context';
import { Box, MenuItem } from '@mui/material';
import deleteComponentFromPage from 'app/app/editor/page/deleteComponentFromPage';
import { IMenuItem } from 'app/app/editor/tabs/elements/layout/context-menu/index';
import IconMi from 'components/common/icon/IconMi';
import styles from './ContextMenu.styles';

export default function MenuItemDelete({ openWithUid, handleClose }: IMenuItem) {
    const { t } = useBundleTranslation(['app/portal-page-builder']);
    const ctx = useAppBuilderContext();
    if (openWithUid == 'page') {
        return null;
    }
    return (
        <MenuItem
            onClick={() => {
                const newPage = deleteComponentFromPage(ctx.page, openWithUid);
                ctx.setPage(newPage, false);
                ctx.sendMessage({ name: 'reloadPage' });
                handleClose();
            }}
        >
            <Box sx={{ ...styles.iconHolder, color: 'error.main' }}>
                <IconMi icon={'delete'} />
            </Box>
            <Box>{t('node_context_menu.remove')}</Box>
        </MenuItem>
    );
}
